import { MARQUEE_WORDS } from "../config/content";

export default function Marquee({ faint = false }) {
  const words = [...MARQUEE_WORDS, ...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div
      className={`relative overflow-hidden py-8 md:py-10 border-y border-[#17231B] ${faint ? "opacity-40" : ""}`}
      data-testid={faint ? "marquee-faint" : "marquee-strip"}
      aria-hidden="true"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-heading uppercase text-6xl md:text-8xl tracking-wide ${i % 2 === 0 ? "text-[#22C55E]/[0.13]" : "text-white/[0.06]"}`}>
              {w}
            </span>
            <span className="mx-8 md:mx-12 text-[#FACC15]/25 text-2xl md:text-4xl">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
